import "maplibre-gl/dist/maplibre-gl.css";

import * as ReactDOM from "react-dom/client";

import { initMapLibreGl } from "@ryde/controls";
import { ApplicationType, setApplicationType } from "@ryde/shared";

import { AppRootLandingSpa } from "./app";

initMapLibreGl();

setApplicationType(ApplicationType.Landings);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(<AppRootLandingSpa />);
